import { gql } from "@apollo/client";

//* ສະຖິຕິຮ້ານ (ຜູ້ຕິດຕາມ / ຂາຍແລ້ວ / ຣີວິວ) — ໃຊ້ backend ດຽວກັນກັບໜ້າ sale page (about-us)

//* ນັບຈຳນວນຜູ້ຕິດຕາມຂອງຮ້ານ → ໃຊ້ userFollowers.total
export const GET_USER_FOLLOWERS = gql`
  query UserFollowers(
    $where: UserFollowerWhereInput
    $skip: Int
    $limit: Int
  ) {
    userFollowers(where: $where, skip: $skip, limit: $limit) {
      total
      data {
        id
      }
    }
  }
`;

//* ຈຳນວນອໍເດີ້ທີ່ຂາຍໄດ້ (COMPLETED) — ໃຊ້ orderGroups.total ໃຫ້ຕົງກັບໜ້າ CreateInvoice
//* ຂໍແຕ່ total ພຽງຢ່າງດຽວ (ບໍ່ດຶງ data ເພື່ອໃຫ້ເບົາ)
export const GET_SHOP_SOLD_ORDER_COUNT = gql`
  query OrderGroups(
    $where: OrderGroupWhereInput
    $skip: Int
    $limit: Int
  ) {
    orderGroups(where: $where, skip: $skip, limit: $limit) {
      total
    }
  }
`;

//* ຣີວິວຮ້ານ — ໃຊ້ comment ທີ່ຜູກກັບ shop, ຄັດເອົາສະເພາະ review ຮ້ານ (ບໍ່ມີ product) ຝັ່ງ client
export const GET_SHOP_COMMENTS = gql`
  query Comments($where: CommentWhereInput) {
    comments(where: $where) {
      total
      averageRating
      data {
        id
        rate
        product {
          id
        }
        productVariant {
          id
        }
      }
    }
  }
`;
